import React from "react";
import { List, Datagrid, TextField, DateField, ShowButton, EditButton } from "react-admin";
import { Pagination } from "react-admin";
import CsvButton from "./CsvButton";
import DefaultButton from "./DefaultButton";
import ActiveButton from "./ActiveButton";
import CouponsButton from "./CouponsButton";
import { isAdmin } from "./../../services/LocalStorage";

const CustomPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export const CampaignList = (props) => (
  <List {...props} title="Users" pagination={<CustomPagination/>} perPage={30}>
    <Datagrid>
      <TextField source="originId" label="ID"/>
      {isAdmin() && <TextField source="coreShopId" label="Core shop ID"/>}
      <TextField source="title" label="Title"/>
      <ActiveButton label="Active"/>
      <DefaultButton label="Default"/>
      <DateField source="startDate" label="startDate"/>
      <DateField source="endDate" label="endDate"/>
      <CouponsButton/>
      <CsvButton/>
      <ShowButton/>
      <EditButton/>
    </Datagrid>
  </List>
);
